import { Box, Button, Container, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import globalContext from '../context/context'
import axios from "axios";
import { useTranslation } from "react-i18next";
import WalletPrice from "../utils/WalletPrice";
function MyBooking() {

    const { t } = useTranslation();
    const { contextData: { user, authKey }, login, isLoggedIn, deleteMyProfile } = useContext(globalContext);
    const navigate = useNavigate();
    const [bookings, setBookings] = useState([]);
    const [showOld, setShowOld] = useState(false);
    
    const getProductTypes = (b) => {
        const types = [];
        if (b?.directionFrom?.departureTransfer || b?.directionFrom?.arrivalTransfer || b?.directionTo?.departureTransfer || b?.directionTo?.arrivalTransfer) {
            types.push('Transfer');
        }
        if (b?.directionFrom?.departureLounge || b?.directionTo?.departureLounge) {
            types.push('Lounge');
        }
        if (b?.directionFrom?.departureParking || b?.directionTo?.departureParking) {
            types.push('Parking');
        }
        if (b?.directionFrom?.departureFastTrack || b?.directionTo?.departureFastTrack) {
            types.push('Fast Track');
        }
        return types.join(', ');
    }
    

    useEffect(() => {
        if (!authKey) {
            navigate('/login');
        } else {

            if (isLoggedIn()) {
                axios.get(`/api/my-booking/customers/${user?.id}/orders`)
                    .then(res => {
                        if (res?.data) {
                            setBookings(res?.data);
                        }
                    }).catch(err => console.log(err))
            }

        }
    }, [user, authKey])


    const filterBookings = (bs) => {
        if(!showOld){
            return bs.filter((b) => {
                return new Date(b?.directionFrom?.flightDeparture) > new Date();
            })
        } else{
            return bs;
        }
    }


    return (
        <Box sx={{ py: 5, bgcolor: 'rgba(0,0,0, .2)' }}>
            <Container>
                <Paper sx={{ p: 3, bgcolor: '#fff', m: 3 }}>
                    <Typography sx={{ fontSize: '32px', fontWeight: 300, textAlign: 'center', pb: 2 }}>{t("MyBooking.myBookings")}</Typography>
                    <Typography sx={{ fontSize: '22px', fontWeight: 300, textAlign: 'center', pb: 2 }}>Wallet credits: <WalletPrice /></Typography>
                    <Button component={Link} to="/my-cart">{t("MyBooking.myCarts")}</Button>
                    {!showOld?<Button onClick={() => setShowOld(true)}>{t("MyBooking.showPast")}</Button>:<Button onClick={() => setShowOld(false)}>{t("MyBooking.hidePast")}</Button>}
                    <Button size="small" variant="contained" color="error" onClick={() => deleteMyProfile()}>{t("MyBooking.deleteMyProfile")}</Button>
                    <Box sx={{ width: '100%' }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t("MyBooking.orderNr")}</TableCell>
                                    <TableCell align="right">{t("MyBooking.name")}</TableCell>
                                    <TableCell align="right">{t("MyBooking.flightNr")}</TableCell>
                                    <TableCell align="right">{t("MyBooking.products")}</TableCell>
                                    <TableCell align="right">{t("MyBooking.price")}</TableCell>
                                    <TableCell align="right">{t("MyBooking.status")}</TableCell>
                                    <TableCell align="right">{t("MyBooking.date")}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filterBookings(bookings).map(b => (<TableRow key={b.id}>
                                    <TableCell component="th" scope="row">
                                        {b?.order?.status === 'CANCELLED' ? t("MyBooking.deleted") : <Link to={`/my-booking/${b?.order?.id}`} >PLUS{String(b?.order?.id).padStart(8, '0')}</Link>}
                                    </TableCell>
                                    <TableCell align="right">{b?.firstName} {b?.surname}</TableCell>
                                    <TableCell align="right">{b?.directionTo?.flightNumber} {b?.directionFrom?.flightNumber}</TableCell>
                                    <TableCell align="right">{getProductTypes(b)}</TableCell>
                                    <TableCell align="right">{b?.order?.totalAmountInEuro} EUR</TableCell>
                                    <TableCell align="right">
                                        <span style={{
                                            color: b?.order?.status === 'PENDING_PAYMENT' ? '#d32f2f' : 
                                                   b?.order?.status === 'COMPLETED' ? '#2e7d32' : 
                                                   b?.order?.status === 'CANCELLED' ? '#757575' : 'inherit',
                                            fontWeight: b?.order?.status === 'PENDING_PAYMENT' ? 'bold' : 'normal'
                                        }}>
                                            {b?.order?.status === 'CANCELLED' ? t("MyBooking.deleted") : b?.order?.status}
                                        </span>
                                    </TableCell>
                                    <TableCell align="right">{b?.order?.orderDate?new Date(b?.order?.orderDate).toLocaleDateString():''}</TableCell>
                                </TableRow>))}
                            </TableBody>
                        </Table>
                    </Box>
                </Paper>
            </Container>

        </Box>


    );
}

export default MyBooking;
